import axios from "axios";
import { BasedURL } from "../../util/constants";

function isTokenExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
}

function logout() {
    localStorage.removeItem("access_token");
    window.location.href = "/login";
}

const AxiosInstance = axios.create({
    baseURL: BasedURL
});

AxiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token');
        if (token) {
            if (isTokenExpired(token)) {
                logout();
                return Promise.reject(new Error("Token expired"));
            }
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

AxiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            logout();
        }
        return Promise.reject(error);
    }
);

export default AxiosInstance;